import React, { Component } from "react";
import { connect } from "react-redux";
import { AreYouAgreeModal, BreadCumb, DataTables, NavBar, TimeOut } from "../../components";
import config from "../../config";
import moment from 'moment';
import ApiClient from "../../libs/apiClient";
import { DISPATCH_ID, SERVICE_RESPONSE } from "../../libs/utils/Const";
import $ from 'jquery';
import { saveAs } from 'file-saver';
var JSZip = require("jszip");

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Estatus Pago", value: true },
    { title: "Num.Doc", value: true },
    { title: "Cliente", value: true },
    { title: "Nombre", value: true },
    { title: "Folio", value: true },
    { title: "Fecha", value: true },
    { title: "Total", value: true },
    { title: "Estatus", value: true },]

class citibanamexView extends Component {
    constructor(props) {
        super(props)
        this.state = {
            headers: headersDataTable,
            data: [],
            _user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            vendorData: {
                CardCode: '',
                CardName: '',
            },
            vendorsList: [],
            showVendorsModal: false,
            totalPage: 0,
            transactionDocs: [],
            showCitiBanamexModal: false,
            lastData:{},
            typeTransaction: 'SAP',
            docTypeSuggestion:'expiredDocs'
        }
    }
    async componentDidMount() {
        let today = moment(new Date()).format('YYYYMMDD');
        let lastMonth = (moment().subtract(1, 'month')).format('YYYYMMDD');

        let date = {
            dateInit: lastMonth,
            dateFinal: today,
            docFilter: "OPCH",
            docNumSearch: "--",
            docStatus: "---",
            employeeValue: "---",
            groupCodeValue: "---",
            searchSerieName: "--",
        }

        await this.callDocumentsListService(date);
    }

    generateTXT = async arrDocs => {
        const { enableSpinner, notificationReducer: { showAlert }, } = this.props
        const { data } = this.state
        const docs = []
        enableSpinner(true)
        for (let [key, value] of arrDocs) {
            if (value === true) {
                if (data[key].DocStatus === 'C') {
                    enableSpinner(false)
                    return showAlert({ type: 'warning', message: 'El documento ' + data[key].DocNum + ' ya se encuentra cerrado' }, 5000);
                }
                docs.push(data[key])
            }
        }

        enableSpinner(false)
        if (docs.length > 0) {
            enableSpinner(true)
            const responseCITI = await apiClient.getCitibanamexDocsDetails(docs);
            enableSpinner(false)

            if (responseCITI.status === SERVICE_RESPONSE.SUCCESS) {
                for (let i = 0; i < responseCITI.data.length; i++) {
                    responseCITI.data[i].validations = {
                        AccountNum: 0, // -1: Datos incompletos. 1: Cuenta de Cheques. 2: Tarjeta de Débito. 3: Cuenta CLABE. 4: Num. Celular
                        Address: 0, // -1: Datos incompletos.
                        RFC: 0, // -1: Datos incompletos. -2: Formato incorrecto
                        Email: 0, // -1: Datos incompletos. -2: Formato incorrecto
                    };
                }
                await this.setState({
                    transactionDocs: responseCITI.data,
                    showCitiBanamexModal: true
                });
                $("#CitibanamexTransactionsModal").modal("show");
            } else {
                showAlert({ type: 'warning', message: responseCITI?.message ?? 'No se pueden leer estos archivos' }, 5000);
            }
        } else {
            showAlert({ type: 'warning', message: 'No se seleccionó ningún documento' }, 5000);
        }
    }

    openAgreeModal = async () => {
        $("#areYouAgreeModal").modal("show");
    }
    hideAgreeModal = async () => {
        $("#areYouAgreeModal").modal("hide");
    }
    refreshDocuments = async (transactionDocs) => {
        await this.setState({ transactionDocs });
    }

    cleanData = () => {
        this.setState({
            showVendorsModal: false,
            vendorsList: [],
            totalPage: 0,
        })
    }


    searchDocuments = async date => {
     }
    refreshVendor = vendorData => {
        this.setState({
            vendorData
        })
    }

    searchVendors = async newVendors => {
        this.setState({
            vendorsCopy: newVendors
        })
    }
    sendInfo = async docFilter => {
        const { transactionDocs,lastData } = this.state
        const { enableSpinner, notificationReducer: { showAlert }, } = this.props
        showAlert({ type: 'warning', message: 'Este proceso tardará unos minutos, porfavor espere...' }, 5000);
        enableSpinner(true)
        const responseCITI = await apiClient.createTXT(transactionDocs,docFilter);
        if (responseCITI.status === SERVICE_RESPONSE.SUCCESS) {
            showAlert({ type: 'success', message: 'Operación exitosa,Se descargaron sus archivos' }, 5000);
            if (responseCITI.data.correctFiles.length > 0) {
                const zip = new JSZip();
                for (let index = 0; index < responseCITI.data.correctFiles.length; index++) {//AÑADIR PAGOS
                    const curfile = responseCITI.data.correctFiles[index];
                    zip.file(curfile.fileName, curfile.fileData);

                }
                if (responseCITI.data.complements.length > 0) {//AÑADIR COMPLEMENTOS
                    for (let index = 0; index < responseCITI.data.complements.length; index++) {
                        const file = responseCITI.data.complements[index];
                        zip.file(file.fileName, file.fileData);
                    }

                }
                if (responseCITI.data.regTotal.length > 0) {//AÑADIR ARCHIVO TRAILER
                    for (let index = 0; index < responseCITI.data.regTotal.length; index++) {
                        const file = responseCITI.data.regTotal[index];
                        zip.file(file.fileName, file.fileData);
                    }
                }
                zip.generateAsync({ type: "blob" }).then(function (content) {
                    saveAs(content, "Citibanamex_CorrectFiles.zip");
                });
            }
            if (responseCITI.data.incorrectFiles.length > 0) {
                const zip = new JSZip();
                for (let index = 0; index < responseCITI.data.incorrectFiles.length; index++) {
                    const curfile = responseCITI.data.correctFiles[index];
                    zip.file(curfile.fileName, curfile.fileData);

                }
                zip.generateAsync({ type: "blob" }).then(function (content) {
                    saveAs(content, "Citibanamex_IncorrectFiles.zip");
                });
            }
            await this.callDocumentsListService(lastData)
            $("#CitibanamexTransactionsModal").modal("hide");
            this.setState({
                showCitiBanamexModal: false
            })
        } else {
            const { transactionDocs } = this.state
            if (responseCITI?.data?.length > 0) {
                const auxDocs = transactionDocs.slice()
                for (let index = 0; index < responseCITI.data.length; index++) {
                    const current = responseCITI.data[index];
                    const find = auxDocs.findIndex(doc => { return doc.DocEntry === current.DocEntry });
                    if (find !== -1) {
                        let auxValidations = { ...auxDocs[find].validations }
                        auxValidations.DocEntry = -1
                        auxDocs[find].validations = auxValidations
                        showAlert({ type: 'warning', message: current?.errors ?? '' }, 5000);
                    }
                }
                this.setState({
                    transactionDocs: auxDocs
                })
            }
            showAlert({ type: 'warning', message: responseCITI?.message ?? 'ERRORX1' }, 5000);

        }
        enableSpinner(false)
    }

    addEmptyTransaction = async () => {
        const {transactionDocs} = this.state;

        const newTransaction = {
            DocEntry: -1,
            DocNum: -1,
            CardCode: "",
            CardName: "",
            TransactionCode: "072",
            BankCode: "000",
            AccountNum: "",
            AccountType: "01",
            TotalAmount: "0.00",
            ConceptPayment: "",
            Priority: "N",
            Confidential: "N",
            Comments: "",
            Address: "",
            Address2: "",
            VatSum: "0.00",
            DflAccount: null,
            LicTradNum: "",
            Email: "",
            AvailableBank: null,
            DocumentType: "05",
            AccountNumType: "",
            AccreditationDate: "01",
            Notify: "E-Mail",
            bancos: [],
            availableBank: [],
            validations: {
                AccountNum: -1,
                Address: -1,
                RFC: 0,
                Email: -1
            }
        };
        transactionDocs.push(newTransaction);
        this.setState({ transactionDocs: await this.fillTransactionModel(transactionDocs) });
    }
    changeDocTypeSuggestion = async newValue =>{
        this.setState({docTypeSuggestion:newValue})
    }
    //#region Consultar información
    searchSuggestDoc = async newData =>{
        const { enableSpinner, notificationReducer: { showAlert }, } = this.props;
        const { vendorData } = this.state
        this.setState({ lastData:newData })
        let data = {
            dateInit: newData.dateInit,
            dateFinal: newData.dateFinal,
            switch1: newData.docStatus || '---',
            groupCodeValue: '---',
            table: "CITI",
            docNumSearch: newData.docNumSearch ? newData.docNumSearch === '' ? '--' : newData.docNumSearch : '--',
            searchSerieName: newData.searchSerieName ? newData.searchSerieName === '' ? '--' : newData.searchSerieName : '--',
            docFilter: newData.docFilter ? newData.docFilter === '' ? '--' : newData.docFilter : '--',
            employeeValue: vendorData.CardCode ? vendorData.CardCode === '' ? '---' : vendorData.CardCode : '---',
            docTypeSuggestion:this.state.docTypeSuggestion
        };
        enableSpinner(true);
        let suggestionDocsList = await apiClient.getSuggestionDocs(data);
        enableSpinner(false);
        if (suggestionDocsList.status === SERVICE_RESPONSE.SUCCESS) {
            if (suggestionDocsList.data.length > 0) {
                this.setState({ data: suggestionDocsList.data ?? [] })
            } else {
                this.setState({ data: [] })
                showAlert({ type: 'info', message: 'No se encontraron resultados con los parámetros ingresados' }, 5000);    
            }
        } else {
            showAlert({ type: 'info', message: suggestionDocsList?.message ?? 'No se encontraron resultados con los parámetros ingresados' }, 5000);
        }
    }
    //#region Lista de documentos
    callDocumentsListService = async newData => {
        const { enableSpinner, notificationReducer: { showAlert }, } = this.props;
        const { vendorData } = this.state
        this.setState({ lastData:newData })
        let data = {
            dateInit: newData.dateInit,
            dateFinal: newData.dateFinal,
            switch1: newData.docStatus || '---',
            groupCodeValue: '---',
            table: "CITI",
            docNumSearch: newData.docNumSearch ? newData.docNumSearch === '' ? '--' : newData.docNumSearch : '--',
            searchSerieName: newData.searchSerieName ? newData.searchSerieName === '' ? '--' : newData.searchSerieName : '--',
            docFilter: newData.docFilter ? newData.docFilter === '' ? '--' : newData.docFilter : '--',
            employeeValue: vendorData.CardCode ? vendorData.CardCode === '' ? '---' : vendorData.CardCode : '---',
        };
        enableSpinner(true);
        let deliveriesListResponse = await apiClient.getDocumentsList(data);
        enableSpinner(false);

        if (deliveriesListResponse.status === SERVICE_RESPONSE.SUCCESS) {
            if (deliveriesListResponse.data.length > 0) {
                this.setState({ data: deliveriesListResponse.data ?? [] })
            } else {
                this.setState({ data: [] })
                showAlert({ type: 'info', message: 'No se encontraron resultados con los parámetros ingresados' }, 5000);    
            }
        } else {
            showAlert({ type: 'info', message: deliveriesListResponse?.message ?? 'No se encontraron resultados con los parámetros ingresados' }, 5000);
        }
    }
    //#endregion

    //#region Lista de proveedores
    openVendor = async (func) => {
        const { enableSpinner, notificationReducer: { showAlert } } = this.props;
        const { vendorData } = this.state
        const CardCode = vendorData.CardCode || null;

        enableSpinner(true);
        const getVendorResponse = await apiClient.getVendors(CardCode);
        enableSpinner(false);
        if (getVendorResponse.status === SERVICE_RESPONSE.SUCCESS) {
            if (getVendorResponse.data.vendors.length === 0) {
                showAlert({ type: 'warning', message: 'NO SE ENCONTRARON RESULTADOS' }, 5000);
            }  else {
                this.setState({
                    vendorsList: getVendorResponse?.data.vendors ?? [],
                    totalPage: getVendorResponse?.data.totalrows ?? 0,
                    showVendorsModal: true,
                })
                $('#VendorsModal').modal('show');
            }
        } else {
            showAlert({ type: 'warning', message: getVendorResponse?.message ?? 'NO VENDORS' }, 5000);
        }
    }
    //#endregion
    
    //#region Detalles de documentos
    getDetailDocuments = async (arrDocs, table, oneDoc = null) => {
        const { enableSpinner, notificationReducer: { showAlert }, } = this.props
        const { data } = this.state
        const docs = []

        enableSpinner(true)
        for (let [key, value] of arrDocs) {
            if (value === true) {
                if (data[key].DocStatus === 'C') {
                    enableSpinner(false)
                    return showAlert({ type: 'warning', message: 'El documento ' + data[key].DocNum + ' ya se encuentra cerrado' }, 5000);
                }
                if(data[key]?.U_FMB_Bank_Status === 'Y'){
                    enableSpinner(false)
                    return showAlert({ type: 'warning', message: 'El documento ' + data[key].DocNum + ' ya está en proceso de pago' }, 5000);
                }
                if(data[key]?.U_FMB_Bank_Status === 'C'){
                    enableSpinner(false)
                    return showAlert({ type: 'warning', message: 'El documento ' + data[key].DocNum + ' ya tiene un pago aplicado' }, 5000);
                }
                docs.push(data[key])
            }
        }

        if (!!oneDoc && docs.length === 0) { docs.push(oneDoc) }

        enableSpinner(false)
        if (docs.length > 0) {
            enableSpinner(true)
            const responseCITI = await apiClient.getCitibanamexDocsDetails(docs,table);
            enableSpinner(false)

            if (responseCITI.status === SERVICE_RESPONSE.SUCCESS) {
                await this.setState({
                    typeTransaction: 'SAP',
                    transactionDocs: this.fillTransactionModel(responseCITI.data),
                    showCitiBanamexModal: true,
                });
                $("#CitibanamexTransactionsModal").modal("show");
            } else {
                showAlert({ type: 'warning', message: responseCITI.message }, 5000);
            }
        } else {
            await this.setState({
                typeTransaction: 'SR-SAP',
                transactionDocs: [],
                showCitiBanamexModal: true,
            });
            await this.addEmptyTransaction();
            $("#CitibanamexTransactionsModal").modal("show");
        }
    }

    fillTransactionModel(documents) {
        const { enableSpinner, notificationReducer: { showAlert }, } = this.props
        if (documents.length > 0) {
            enableSpinner(true);            
            for (let i = 0; i < documents.length; i++) {
                const document = documents[i];
                let validations = {
                    AccountNum: -1, // -1: Datos incompletos. 1: Num. Celular. 2: Tarjeta de Débito. 3: Cuenta CLABE.  4: Cuenta de Cheques.
                    Address: -1, // -1: Datos incompletos.
                    RFC: 0, // -1: Datos incompletos. -2: Formato incorrecto
                    Email: -1, // -1: Datos incompletos. -2: Formato incorrecto
                };
                if(document.BankCode === '000' && document.AccountNum.length > 0 && !isNaN(Number(document.AccountNum))){
                    document.TransactionCode = '072'
                    if (document.AccountNum.length === 10) {
                        document.AccountNumType = '07';
                        document.validations.AccountNum = 1;
                    }
                    else if (document.AccountNum.length === 16) {
                        document.AccountNumType = '03';
                        document.validations.AccountNum = 2;
                    }
                    else if (document.AccountNum.length === 18) {
                        document.AccountNumType = '05';
                        document.validations.AccountNum = 3;
                    }
                    else if (document.AccountNum.length === 11) {
                        document.AccountNumType = '01';
                        document.validations.AccountNum = 4;
                    }
                }
                if(document.BankCode !== '000' && document.AccountNum.length === 18 && !isNaN(Number(document.AccountNum)) ){
                    validations.AccountNum = 3
                    document.TransactionCode = '001'
                }

                // if (document.TransactionCode === '072') { // Formatos validos para Trans. Entre Cuentas
                //     if (document.AccountNum.length === 10) { validations.AccountNum = 1; } 
                //     else if (document.AccountNum.length === 16) { validations.AccountNum = 2; }
                //     else if (document.AccountNum.length === 18) { validations.AccountNum = 3; }
                //     else if (document.AccountNum.length === 11) { validations.AccountNum = 4; }
                // } else if (document.TransactionCode === '001') { // Formatos validos para Trans. Interbancarias
                //     if (document.AccountNum.length === 10) { validations.AccountNum = 1; }
                //     else if (document.AccountNum.length === 16) { validations.AccountNum = 2; }
                //     else if (document.AccountNum.length === 18) { validations.AccountNum = 3; }
                // } else { validations.AccountNum = 0; } // No aplica para otros tipos de Transacción

                if (document.Address) {
                    if (document.Address.trim().length > 0 && document.Address.trim() !== '') {
                        validations.Address = 0;
                    }
                }

                const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                if (document.Email && document.Email.trim() !== '') {
                    validations.Email = -2;
                    if (validEmail.test(document.Email) && document.Email.length <= 50) { validations.Email = 0; }
                }
                documents[i].validations = validations;
            }
            enableSpinner(false);
            return documents;
        } else {
            showAlert({ type: 'warning', message: 'No se seleccionó ningún documento' }, 5000);
        }
    }
    //#endregion
    resetDataTable = async()=>{
        this.setState({
            data: []
        })
    }
    //#region Descargar TXT
    downloadTXT = async (document, docFilter) => {
        const { enableSpinner, notificationReducer: { showAlert }, } = this.props
        const data = {
            table: docFilter,
            docEntry: document.DocEntry,
            docNum: document.DocNum
        };
        const typeDoc = docFilter === 'OPCH' ? 'F' : 'O';

        enableSpinner(true);
        const responseApi = await apiClient.downloadPaymentFile(data);
        if (responseApi.status === 0 || !responseApi?.data?.downloadedTXT) { showAlert({ type: 'warning', message: responseApi.message ?? 'Ocurrio un error al descargar el archivo' }, 5000); }
        else {
            const zip = new JSZip();
            const file = responseApi.data.downloadedTXT;
            zip.file(file.fileName, file.fileData);
            zip.generateAsync({ type: "blob" }).then(function (content) {
                saveAs(content, `${typeDoc}_${document.DocNum}_${document.DocEntry}.zip`);
            });
            showAlert({ type: 'success', message: 'Operación exitosa, archivo descargado' }, 5000);
        }
        enableSpinner(false);
    }
    //#endregion

    //#endregion

    render() {
        const { headers, data, _user, vendorData, showVendorsModal, vendorsList, totalPage, transactionDocs, showCitiBanamexModal, typeTransaction, docTypeSuggestion } = this.state;

        return (
            <div className="content">
                <NavBar props={this.props} _user={_user} />
                <BreadCumb subitem1={'GESTIÓN CITIBANAMEX'} url1={'#'} />
                <TimeOut />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>

                    <h2 className="md-display-1">
                        {/* <a id="linkOrdProv" className="text-muted"> */}
                            &nbsp;GESTIÓN CITIBANAMEX
                        {/* </a> */}
                    </h2>
                    <DataTables
                        headers={headers}
                        view={"citibanamex"}
                        data={data}
                        search={this.callDocumentsListService}
                        vendorData={vendorData}
                        selectBusinessParter={this.selectBusinessParter}
                        refreshVendor={this.refreshVendor}
                        openVendor={this.openVendor}
                        showVendorsModal={showVendorsModal}
                        vendorsList={vendorsList}
                        totalPage={totalPage}
                        cleanData={this.cleanData}
                        generateTXT={this.getDetailDocuments}
                        downloadTXT={this.downloadTXT}
                        showCitiBanamexModal={showCitiBanamexModal}
                        transactionDocs={transactionDocs}
                        typeTransaction={typeTransaction}
                        refreshDocuments={this.refreshDocuments}
                        openAgreeModal={this.openAgreeModal}
                        sendInfo={this.sendInfo}
                        hideAgreeModal={this.hideAgreeModal}
                        addTransaction={this.addEmptyTransaction}
                        searchSuggestDoc={this.searchSuggestDoc}
                        docTypeSuggestion={docTypeSuggestion}
                        changeDocTypeSuggestion={this.changeDocTypeSuggestion}
                        resetDataTable={this.resetDataTable}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(citibanamexView);